import backup from './backupApi';
import tenantBackup from './tenantBackupApi';
import serverlessBackup from './serverlessBackupApi';
import * as churnSurvey from './churnSurveyApi';
import clusterForm from './clusterFormApi';
import clusterDescriptions from './clusterDescriptionsApi';
import geoZoneMap from './geoZoneMapApi';
import userSecurity from './userSecurityApi';
import networkSettings from './networkSettingsApi';
import auditLog from './auditLogApi';
import roles from './rolesApi';
import users from './usersApi';
import * as encryptionAtRest from './encryptionAtRestApi';
import maintenanceWindows from './maintenanceWindowsApi';
import loadSampleDatasetApi from './loadSampleDatasetApi';
import dataLakes from './dataLakesApi';
import groupStatus from './groupStatusApi';
import liveImports from './liveImportsApi';
import ftsIndexConfig from './ftsIndexConfigApi';
import * as privateEndpoint from './privateEndpointApi';
import * as container from './containerApi';
import * as admin from './adminApi';
import * as awsCustomDNS from './awsCustomDNSApi';
import * as onlineArchive from './onlineArchiveApi';
import * as tenantUpgrade from './tenantUpgradeApi';
import * as cloudProviderAccess from './cloudProviderAccessApi';
import * as projectSettings from './projectSettingsApi';
import serverlessInstances from './serverlessInstancesApi';
import serverlessInstanceForm from './serverlessInstanceFormApi';
import serverlessTenantMigrations from './serverlessTenantMigrationsApi';
import * as privateNetworkSettings from './privateNetworkSettingsApi';
import * as personalizationWizard from './PersonalizationWizardApi';
import * as ingestionPipelines from 'js/common/services/api/nds/ingestionPipelinesApi';
import * as limits from './limitsApi';
import * as serverlessPrivateEndpoint from './serverlessPrivateEndpointApi';

export default {
  backup,
  tenantBackup,
  serverlessBackup,
  churnSurvey,
  clusterDescriptions,
  clusterForm,
  geoZoneMap,
  userSecurity,
  networkSettings,
  auditLog,
  users,
  roles,
  encryptionAtRest,
  maintenanceWindows,
  loadSampleDatasetApi,
  dataLakes,
  groupStatus,
  liveImports,
  privateEndpoint,
  container,
  admin,
  ftsIndexConfig,
  awsCustomDNS,
  onlineArchive,
  tenantUpgrade,
  cloudProviderAccess,
  serverlessInstances,
  serverlessInstanceForm,
  serverlessTenantMigrations,
  projectSettings,
  privateNetworkSettings,
  personalizationWizard,
  ingestionPipelines,
  limits,
  serverlessPrivateEndpoint,
};
